import e from "../input-group/input-group.js";
//#region components/checkbox_group/checkbox_group.vue
var t = {
	compatConfig: { MODE: 3 },
	name: "DtCheckboxGroup",
	extends: e,
	props: {
		modelValue: {
			type: Array,
			default() {
				return [];
			}
		},
		dataQaGroup: {
			type: String,
			default: "checkbox-group"
		},
		dataQaGroupLegend: {
			type: String,
			default: "checkbox-group-legend"
		},
		dataQaGroupMessages: {
			type: String,
			default: "checkbox-group-messages"
		}
	},
	emits: ["update:modelValue"],
	data() {
		return { internalValue: this.modelValue };
	},
	watch: {
		modelValue(e) {
			this.internalValue = e;
		},
		internalValue: {
			immediate: !0,
			handler(e) {
				this.provideObj.selectedValues = e;
			}
		}
	},
	methods: {
		setGroupValue(e, t) {
			t ? this.internalValue.includes(e) || this.internalValue.push(e) : this.internalValue = this.internalValue.filter((t) => t !== e), this.$emit("update:modelValue", this.internalValue);
		},
		getMessageKey(e, t) {
			return `checkbox-group-message-${e}-${t}-${this.id}`;
		}
	}
};
//#endregion
export { t as default };

//# sourceMappingURL=checkbox-group.js.map